import ContactSuccessPage from './contact-success-page';

export default ContactSuccessPage;
